import { z } from 'zod'
import { ContentfulAssetSchema, ContentfulBynderImageSchema } from './asset'

export const ContentfulCrossSellingSchema = z.object({
  identifier: z.string(),
  image: ContentfulAssetSchema,
  bynderImage: z.array(ContentfulBynderImageSchema).optional(),
  heading: z.string(),
  text: z.string(),
  href: z.string().optional().nullable(),
  buttonText: z.string().optional().nullable(),
})
export type ContentfulCrossSelling = z.infer<typeof ContentfulCrossSellingSchema>

export const ContentfulCrossSellingCollectionSchema = z.object({
  crossSellingCollection: z.object({
    items: z
      .array(ContentfulCrossSellingSchema.nullable())
      .transform((arr) => arr.filter((item): item is ContentfulCrossSelling => item !== null)),
  }),
})
export type ContentfulCrossSellingCollection = z.infer<
  typeof ContentfulCrossSellingCollectionSchema
>
